import { CreateAiPersonaPage } from "@/features/ai/create-ai-persona.page";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/new",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { project } = ProjectRoute.useRouteContext();

  return <CreateAiPersonaPage containerId={project.id} />;
}
